export default {
    values: {
        'Showing: %n templates': [
            [0, 0, 'Nenhum template encontrado'],
            [1, 1, 'Mostrando: 1 modelo'],
            [2, null, 'Mostrando: %n modelos']
        ],
        Alias: 'Pseudônimo',
        Templates: 'Modelos',
        Author: 'Autor',
        annotations: 'Anotações',
        properties: 'Propriedades',
        color: 'Cor',
        'New template': 'Novo modelo',
        'Search for templates': 'Pesquisar modelos',
        Enable: 'Habilitar',
        Disable: 'Desabilitar',
        Duplicate: 'Duplicar',
        discard_changes: 'Descartar mudanças',
        'form json': 'Formulário JSON',
        'Select...': 'Selecione...',
        'Template saved successfully': 'Modelo salvo com sucesso',
        'Error saving template': 'Erro ao salvar o modelo',
        'Template successfully deleted': 'Modelo excluído com sucesso',
        "Invalid JSON in 'Schema' field": "JSON inválido no campo 'Schema'",
        "Invalid JSON in 'UI Schema' field": "JSON inválido no campo 'UI Schema'",
        'The template must have an alias': 'O modelo deve ter um pseudônimo',
        'The template must have a color': 'O modelo deve ter uma cor',
        'Invalid JSON in "Schema" field': 'JSON inválido no campo "Schema"',
        'The template form must have at least one field': 'O formulário do modelo deve ter pelo menos um campo',
        'Non-editable': 'Não editável',
        'Templates cannot be edited, you can duplicate it to create a similar one':
            'Os modelos não podem ser editados, você pode duplicá-lo para criar um similar',
        'Failed to delete template': 'Falha ao excluir o modelo',
        'Failed to enable templates': 'Falha ao habilitar modelos',
        'Failed to disable templates': 'Falha ao desabilitar os modelos',
        'Template deleted successfully': 'Modelo excluído com sucesso',
        'Template enabled successfully': 'Modelo habilitado com sucesso',
        'Template disabled successfully': 'Modelo desabilitado com sucesso',
        'Templates enabled successfully': 'Modelos habilitados com sucesso',
        'Templates disabled successfully': 'Modelos desabilitados com sucesso',
        'Template duplicated successfully': 'Modelo duplicado com sucesso',
        'Failed to duplicate template': 'Falha ao duplicar o modelo',
        from: 'De',
        'to (optional)': 'Até (opcional)',
        Rigs: 'Sondas',
        Wells: 'Poços',
        Crews: 'Equipes',
        'Select a rig': 'Selecione uma sonda',
        'Select a well': 'Selecione um poço',
        'Select a crew': 'Selecione uma equipe',
        'Select a template': 'Selecione um template',
        'Free text area': 'Texto livre',
        'Pick list': 'Seleção',
        Number: 'Número',
        Date: 'Data',
        'Date & Time': 'Data e hora',
        'Created at': 'Criado em',
        'Form elements': 'Elementos de formulário',
        'Form builder': 'Construtor de formulário',
        From: 'De',
        'To (optional)': 'Até (opcional)',
        Elements: 'Elementos',
        Configuration: 'Configuração',
        'text & info': 'texto & informação',
        choice: 'escolha',
        Checkbox: 'Caixa de seleção',
        'Preview annotations timestamp': 'Prévia com campos de começo e fim',
        'Use rigs': 'Usar sondas',
        'Use wells': 'Usar poços',
        'Use crews': 'Usar equipes',
        'Read only': 'Somente leitura',
        'Add item': 'Adicionar item',
        'Are you sure you want to delete this template? This action cannot be undone':
            'Tem certeza de que deseja excluir este modelo? Esta ação não pode ser desfeita',
        "To delete the template, type 'DELETE' in the field down below":
            "Para excluir o modelo, digite 'DELETE' no campo abaixo",
        'Type DELETE here to confirm': 'Digite DELETE aqui para confirmar',
        "Couldn't find templates for this dashboard.": 'Não foi possível encontrar modelos para este dashboard.',
        'Annotation template does not exist': 'O modelo de anotação não existe',
        'Annotation template already exists': 'O modelo de anotação já existe',
        "Couldn't find templates for this dashboard": 'Não foi possível encontrar modelos para este dashboard.',
        'Advanced annotation color must not be empty': 'A cor da anotação avançada não pode estar vazia',
        'Advanced annotation data must not be empty': 'Os dados da anotação avançada não podem estar vazios',
        'Advanced annotation begin must not be empty': 'A data de início da anotação avançada não pode estar vazio',
        'Advanced annotation end period must be greater than begin period':
            'A data de fim da anotação avançada deve ser maior que a data de começo',
        'Advanced annotation template id must not be empty': 'O id do modelo de anotação avançada não pode estar vazio',
        'Advanced annotation template name must not be empty':
            'O nome do modelo de anotação avançada não pode estar vazio',
        'Advanced annotation dashboard id must not be empty':
            'O id do dashboard da anotação avançada não pode estar vazio',
        'Advanced annotation dashboard filters must not be empty':
            'Os filtros do dashboard da anotação avançada não podem estar vazios',
        'Annotation template must not be null': 'O modelo de anotação não pode ser nulo',
        'Template alias must not be empty': 'O pseudônimo do modelo de anotação não pode estar vazio',
        'Template color must not be empty': 'A cor do modelo de anotação não pode estar vazia',
        'Template perspective must not be empty': 'A perspectiva do modelo de anotação não pode estar vazia',
        'Template schema must not be empty': 'O schema do modelo de anotação não pode estar vazio',
        'Annotation saved successfully': 'Anotação salva com sucesso',
        'Annotation deleted successfully': 'Anotação excluída com sucesso',
        'The number of template has reached a maximum. Please reach to support to increase your number of templates.':
            'O número de modelos atingiu o máximo. Entre em contato com o suporte para aumentar o número de modelos.',
        "Couldn't check template limit": 'Não foi possível verificar o limite de modelos',
        'Template settings': 'Configurações do modelo',
        'Number of templates': 'Quantidade de modelos',
        'This configuration will limit annotation templates per environment':
            'Essa configuração limitará a quantidade de modelos de anotação por ambiente',
        'Annotation template': 'Modelo de anotação',
        'Advanced annotations': 'Anotações avançadas',
        "Template perspective must match the dashboard's perspective":
            'A perspectiva do modelo desejado deve corresponder à perspectiva do dashboard',
        "Templates must match the dashboard's perspective": 'Os modelos devem corresponder à perspectiva do dashboard',
        'Last modified at': 'Última modificação em',
        'Click or Drag & drop elements to preview.': 'Clique ou arraste e solte elementos para pré-visualizar.',
        'Form preview': 'Pré-visualização do formulário',
        'This view is for preview only and data editing is not possible.':
            'Esta visualização é apenas para pré-visualização e não é possível editar dados.',
        'No form element added': 'Nenhum elemento de formulário adicionado',
        'No element selected': 'Nenhum elemento selecionado',
        'Element Properties': 'Propriedades do elemento'
    }
}
